export const SHIPMENT_CAPABILITY = {
  DOOR: 'DOOR',
}

export const DEFAULT_SHIPMENT_PROVIDER = 'DHL'
